<script setup lang="ts">
import type { IgMediaItem } from '~~/src/core/types';
import { assert } from '~~/src/layers/toolkit/toolkit';

const props = defineProps<{
  index: number;
  post?: IgMediaItem;
  loading?: boolean;
}>();

const to = computed(() =>
  props.loading ? '#' : (props.post?.permalink ?? '#'),
);
const isVideo = computed(() => props.post?.media_type === 'VIDEO');
const tilts = [
  '-rotate-6',
  'z-1 rotate-2',
  'z-2 rotate-10',
  'z-3 -translate-x-8 -rotate-3',
] as const;
const tilt = computed(() => {
  assert(props.index < tilts.length, 'Max allowed posts are 4');
  return tilts[props.index];
});
</script>

<template>
  <AppLink
    type="custom"
    :to
    :opts="{}"
    :class="[tilt, { 'pointer-events-none': loading }]"
    class="relative aspect-4/5 w-40 shrink-0 origin-top overflow-hidden rounded-lg shadow-xl transition-transform delay-75 duration-200 sm:w-48 md:w-56 lg:w-3xs lg:hover:z-5 lg:hover:scale-105 xl:w-2xs 2xl:w-sm"
  >
    <div
      v-if="loading"
      class="bg-client-gray absolute inset-0 flex size-full items-center justify-center"
    >
      <FeedPostLoading />
    </div>
    <video
      v-else-if="isVideo"
      :src="post?.media_url"
      :alt="post?.alt_text"
      autoplay
      muted
      loop
      playsinline
      :controls="false"
      class="h-full w-full object-cover"
    />
    <img
      v-else
      :src="post?.media_url"
      :alt="post?.alt_text"
      class="h-full w-full object-cover"
    />
  </AppLink>
</template>
